module.exports = __webpack_public_path__ + "img/content-paste-go-rounded.e508285c.svg";